import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var Anchor = function Anchor(_ref) {
  var id = _ref.id;
  var getClassName = getClassNameFactory("PageNavAnchor");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName(),
    id: id
  });
};

Anchor.displayName = "PageNav.Anchor";
export default Anchor;